import { ar } from './ar';
import { en } from './en';

export const resources = {
  en: { translation: en },
  ar: { translation: ar },
} as const;

export { ar, en };
export type { EnglishTranslations } from './en';
